import { StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import "angular-formly";
import {
  ContractService,
  vsServiceName as ContractServiceName,
} from "../../shared/ContractService";
const gridId = Symbol("main.contract.instances");
export class ContractInstanceComponentController implements IOnInit {
  static $inject = [
    "$state",
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    RecordGridViewServiceName,
    "$compile",
    ContractServiceName,
  ];
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  contractInstances!: any;
  instancesId: string = "";

  constructor(
    private readonly $state: StateService,
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly recordGridViewService: RecordGridViewService,
    $compile: ICompileService,
    private readonly contractService: ContractService
  ) {
    this.instancesId = this.$stateParams["instancesId"];
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/contract/contractInstance/"
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);

    //const gridConfiguration: GridConfiguration;

    this.columns = [
      columnDefinitionService.getLinkColDef({
        colId: "info",
        headerName: " ",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression:
          "main.contract.type.info.redirect({ type: data.Type, contractId: data.Id})",
        requiresPermission: "contractView",
      }),
      columnDefinitionService.getLinkColDef({
        colId: "edit",
        headerName: "&nbsp;",
        iconClass: "fa fa-pencil text-primary",
        stateExpression:
          "main.contract.type.info.edit({ type: data.Type, contractId: data.Id })",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
      }),
      columnDefinitionService.getStringColDef({
        field: "Type",
        header: "Type",
      }),
      columnDefinitionService.getNumberColDef({
        field: "ContractNumber",
        header: "Contract Numbers",
      }),
      columnDefinitionService.getDateColDef({
        field: "ContractStartDate",
        header: "Start Date",
      }),
      columnDefinitionService.getDateColDef({
        field: "ContractEndDate",
        header: "End Date",
      }),
    ];
  }

  $onInit(): void {}

  getContractTypes() {
    return this.contractService.getContractTypes();
  }
}
